<template>
	<div class="collection">

		<!-- <button class="tool-button" v-on:click="test()">Test</button> -->

		<!-- Collection Row -->
		<div class="control-row control-border" v-if="Collection.modalVars.parentCollectionID ==''"  ref="collection">
			<button class="tool-button" v-if="!selectRoot" v-on:click="removeCollection()"
				v-bind:class="{hover:!activeChild}"
				:disabled="activeChild"
				>X</button>
			<button class="tool-button hover" v-if="selectRoot" v-on:click= "dropChanges()">X</button>
			<button class="tool-button" v-if="!selectRoot" v-on:click="selectCollection()"
				style="font-weight: bold"
				v-bind="Collection.Root"
				v-bind:class="{hover:!activeChild}"
				contenteditable='false'
				:disabled="activeChild || Collection.rootInstanceID !== '' ">...</button>
			<Autocomplete class='select-root'
				v-if="selectRoot"
				v-on:selectedItem="handleRootSelection($event)"
				v-bind:defaultItem="{ID:'',name:''}"
				v-bind:vars="{isCollection:true,limitToList:true,editOnly:false}"
				/>
			<div class="collection-title" v-if="!selectRoot" v-text="Collection.Root.name"/>
		</div>

		<!-- Group Row -->
		<div class="control-row control-border" v-if="Collection.Root.name ==''?false:true">

			<!-- Delete Group Button -->
			<button class="tool-button" v-on:click="deleteGroup()"
				v-if="!Collection.isModal"
				:disabled="disableQueryButtons(1)"
				v-bind:class="{'button-selected': groupMode == 1, hover: !disableQueryButtons(1)}">
				<img class="button-image" :src="require('../assets/Delete.png')" v-bind:class="{disabled:activeChild}"/>
			</button>

			<!-- Create (C) Button  -->
			<button class="tool-button" v-on:click="createGroup()"
				v-bind:class="{hover:!activeChild}"
				:disabled="activeChild"
			>C</button>

			<!-- "-" Remove From Group Button -->
			<button class="tool-button" v-on:click="removeFromGroup()"
				v-bind:class="{hover: !activeChild && group}"
			>-</button>

			<!-- "+" Add To Group Button -->
			<button class="tool-button" v-on:click="addToGroup()"
				v-bind:class="{hover: !activeChild && !group}"
			>+</button>

			<!-- Group Buttons (radio-style) - directly in group-controls like QueryButton is in query-buttons -->
			<div class="groups" v-if="!selectRoot && Collection.editMode > 0 && Collection.Root.ID && Groups && Groups.length > 0">
				<button
					class="tool-button"
					v-for="group in Groups"
					:key="group.ID"
					:class="{ 'button-selected': group.ID === this.group }"
					@click="addMode ? addToGroupDirect(group.ID) : toggleGroupSelection(group.ID)"
				>
					{{ group.name }}
				</button>
			</div>
		</div>

		<!-- Query Row -->
		<div class="control-row control-border" v-if="Collection.Root.name ==''?false:true">

			<!-- Delete Button -->
			<button class="tool-button" v-on:click="queryMode = queryMode!==1?1:0"
				v-if="!Collection.isModal"
				:disabled="disableQueryButtons(1)"
				v-bind:class="{'button-selected': queryMode == 1, hover: !disableQueryButtons(1)}">
				<img class="button-image" :src="require('../assets/Delete.png')" v-bind:class="{disabled:activeChild}"/>
			</button>

			<!-- Pin Button -->
			<button class="tool-button" v-on:click="queryMode = queryMode!==2?2:0"
				v-if="!Collection.isModal"
				v-bind:class="{'button-selected': queryMode == 2, hover: !disableQueryButtons(2)}"
				>
				<img class="button-image" :src="require('../assets/Pin.png')" v-bind:class="{disabled:activeChild || disableQueryButtons(2)}"/>
			</button>

			<!-- all of this Users queries for this Collection -->
			<div class="queries">
				<QueryButton class="query-component" v-on:querySelect="queryHandler($event)"
					v-if="queries"
					v-bind:activeQuery="Collection.flags.activeQuery"
					v-bind:staleFilters="staleFilters"
					v-bind:queries="orderedQueries"
					v-bind:queryMode="queryMode"
					v-bind:enableDropDown="false"
					v-bind:disable="disableQueryButtons(0)"
				/>
			</div>
		</div>

		<!-- Headers -->
		<div class="headers-div" v-if="Collection.Root.ID !==''">

			<!-- Header - Tree -->
			<div class="tree-header-div">
				<div class="col-headings">
					<!-- Tree -->
					<div class="col-heading col-2"
						v-bind:style="{
							'min-width': (Collection.editMode ===0?displayVars.treeWidth + 18:displayVars.treeWidth) + 'px',
							'max-width': (Collection.editMode ===0?displayVars.treeWidth + 18:displayVars.treeWidth) + 'px',
						}">Tree</div>
					<!-- Filters -->
					<div class="col-heading col-3 filter-backgroud"
						v-if="Collection.editMode > 0"
						v-bind:style="{
							'min-width': (displayVars.filterWidth) + 'px',
							'max-width': (displayVars.filterWidth) + 'px',
							'left': displayVars.editInstanceWidth  + 'px'
						}">Filters</div>
				</div>
				<div class="tree-tools">
					<div class="tree-buttons col-2"
						v-bind:style="{
							'min-width': (Collection.editMode ===0?displayVars.treeWidth + 18:displayVars.treeWidth) + 'px',
							'max-width': (Collection.editMode ===0?displayVars.treeWidth + 18:displayVars.treeWidth) + 'px'
					}">
						<!-- Toggle Edit -->
						<button class="tool-button" v-on:click="setEditMode()"
							v-bind:class="{
								'button-selected': Collection.editMode == 0,
								hover:!activeChild && Collection.editITree.ITrees.length == 0
							}"
							:disabled="activeChild || Collection.editITree.ITrees.length > 0 || !authStatus.isAdmin"
						>
						<img class="button-image" :src="require('../assets/Edit.png')"
							v-bind:class="{disabled:activeChild || Collection.rootInstanceID !=='' || !authStatus.isAdmin}"/>
						</button>
						<div class="show-hidden-toggle">
							<input
								:checked="showHiddenBranches"
								:disabled="activeChild"
								:id="'show-hidden-toggle-' + Collection.ID"
								type="checkbox"
								@change="toggleShowHidden($event.target.checked)"
							/>
							<label>Hidden</label>
						</div>
					</div>

					<!-- Filter Buttons -->
					<div class="filter-buttons col-3"
						v-bind:style="{
							'min-width': (Collection.editMode ===0?displayVars.filterWidth + 18:displayVars.filterWidth) +'px',
							'max-width': (Collection.editMode ===0?displayVars.filterWidth + 18:displayVars.filterWidth) +'px',
							'left': displayVars.editInstanceWidth + 'px'
						}"
						v-if="Collection.editMode > 0"
					>
						<BranchButtons v-on:branchToolCode="handleQueryTool($event)"
							v-bind:btnConfig="filterToolCfg"
							v-bind:isDisabled="activeChild"
						/>

						<button class="tool-button"
							v-if="Collection.rootInstanceID !== ''"
							v-on:click="$emit('toggleClickToFilter',{Collection:Collection,state:!Collection.flags.clickToFilter})"
							v-bind:class="{'button-selected': Collection.flags.clickToFilter, hover: !activeChild}"
						>
							<img class="button-image" :src="require('../assets/ArrowInto.png')" v-bind:class="{disabled:activeChild}"/>	
						</button>

						<input class="filter-chkbox"
							v-on:click="$emit('toggleSelections',{Collection:Collection, state:!Collection.flags.filterSelection})"
							:checked="Collection.flags.filterSelection"
							type="checkbox"
						/>
					</div>
				</div>
			</div>

			<!-- Header - editITree -->
			<template v-if="Collection.editITree.ITrees.length>0 && Collection.rootInstanceID !==''">
				<div class="instance-headers-outer-div editInstance-header-div"
					v-bind:style="{'left': '-' + (displayVars.filterWidth + 10) + 'px'}"
					v-for="(ITree) in Collection.editITree.ITrees.slice(0,1)"
					v-bind:key="ITree.ID"
				>
				<div class="instance-headers-div"
					v-bind:style="{
						'min-width': instanceTableWidth(ITree) +'px',
						'max-width': instanceTableWidth(ITree) +'px',
						'flex-direction': 'column' 
					}"
				>
					<div class="col-headings col-heading" v-bind:style="{'background-color':'#fcd4d4'}"
						v-text="headings.editInstance"
					/>
					<div class="instance-scroll-div"></div>
					<div class="instance-header"
						v-on:keyup.esc.stop="$emit('clientInstanceIsActive',{
							ClientInstance:ITree.ClientInstances[0],
							state:false
						})"
						tabindex="0" 
						v-bind:style="{
							'background-color':'#fcd4d4',
						}">

						<!-- INSTANCE TOOLS -->
						<div class="instance-tools">
							<button class="tool-button" v-on:click="doneEdit()"
								v-bind:class="{hover:!activeChild}"
								:disabled="activeChild"
							>
							<img class="button-image" :src="require('../assets/Check.png')" v-bind:class="{disabled: activeChild}"/>
							</button>
							<button class="tool-button" v-on:click="$emit('toggleClickToFilter',{Collection:Collection,state:!Collection.flags.clickToFilter})"
								v-bind:class="{'button-selected': !Collection.flags.clickToFilter, hover: !activeChild}">
								<img class="button-image" :src="require('../assets/ArrowInto.png')" v-bind:class="{disabled: activeChild}"/>	
							</button>
						</div>
					</div>
				</div>
				</div>
			</template>

			<!-- Header - ITrees -->
			<div class="instance-headers-outer-div" v-if="Collection.editMode > 0">
				<div class="col-heading" style="justify-content: space-between;">
					<div style="display: flex; justify-content: flex-start;">
						<button class="tool-button add-instance" v-on:click.stop="setRootInstanceID('create')"
							:disabled="activeChild">
							<img class="button-image" :src="require('../assets/Plus.png')" v-bind:class="{disabled: activeChild }"/>
						</button>
						<button class="tool-button more-button" v-on:click="scrollInstances('-')"
							:disabled="activeChild">
							<img class="button-image" :src="require('../assets/ArrowLeft.png')" v-bind:class="{disabled: activeChild}"/>
						</button>
					</div>
					<div class="col-heading collection-heading" v-text="headings.Collection"
						v-bind:style="{'flex': '0 1 auto', 'justify-content': 'center'}"
					></div>
					<div style="display: flex; justify-content: flex-end;">
						<button class="tool-button more-button" v-on:click="scrollInstances('+')"
							:disabled="activeChild">
							<img class="button-image" :src="require('../assets/ArrowRight.png')" v-bind:class="{disabled: activeChild}"/>
						</button>
					</div>
				</div>

				<div class="instance-scroll-div" v-if="Collection.ITrees.ITrees.length"
					id="h-scroll-1"
					ref="h_scroll_1"
					v-on:scroll.passive="handleScroll($event)"
					>
					<div class="instance-scroll-filler" v-if="Collection.ITrees.ITrees.length"
						v-bind:style="{'width': displayVars.totalInstancesWidth +'px'}">
					</div>
				</div>
				<div class="instance-headers-div" v-if="Collection.editMode > 0 && Collection.ITrees.ITrees.length"
					id="h-scroll-2"
					ref="h_scroll_2"
					v-on:scroll.passive="handleScroll($event)">
					<div class="instance-header"
						v-for="(ITree, index) in visibleInstances"
						v-bind:key="ITree.ID"
						v-bind:style="{
							'min-width': instanceTableWidth(ITree) +'px',
							'max-width': instanceTableWidth(ITree) +'px',
							'padding-right': index === visibleInstances.length - 1 ? '5px' : '5px'
						}">
						<div class="instance-tools">
							<button class="tool-button" v-on:click="editExistingInstance(ITree)"
								v-bind:class="{hover:true}"
								>
								<img class="button-image" :src="require('../assets/Edit.png')">
								</Button>
							<label class="instance-tools">
								<input class="instance-tools" v-on:change="selectITree(ITree)"
									:key="ITree.ID"
									v-bind:class="{hover:!activeChild}"
									type="checkbox"
									:checked="ITree.isSelected"
									:disabled="activeChild || Collection.ITrees.ITrees.filter(iT=>iT.isSelected).length == 1 && Collection.flags.filterSelection"
								/>&nbsp;Sel
							</label>
							<label class="instance-tools" v-if="ITree.ClientInstances[0].ClientBranch.Branch.Child.name == 'Image'">
								<input v-on:change="displayImages(ITree)"
								v-if="ITree.ClientInstances[0].ClientBranch.Branch.Child.name == 'Image'"
									:key="ITree.ID"
									v-bind:class="{hover:!activeChild}"
									type="checkbox"
									:checked="ITree.displayImages"
									:disabled="activeChild || Collection.ITrees.ITrees.filter(iT=>iT.isSelected).length == 1 && Collection.flags.filterSelection"
								/>&nbsp;Img
							</label>&nbsp;


						</div>
					</div>
				</div>
			</div>

		</div>

		<!-- Body -->
		<div class="body-div" :style="bodyDivStyle" ref="bodyDiv">

			<!-- Body - Tree -->
			<TreeTable class="tree-component"
				v-bind:authStatus="authStatus"
				v-bind:Tree="orderedTree"
				v-bind:displayVars="displayVars"
				v-bind:enableEdit="enableEdit"
				v-bind:activeChild="activeChild"
				v-bind:editMode="Collection.editMode"
				v-bind:rootInstanceID="Collection.rootInstanceID"

				v-on:activateChild="$emit('activateChild',$event)"
				v-on:addTempClientBranch="addTempClientBranch($event)"

				v-on:addBranch="$emit('addBranch',{
					ClientBranch:$event.ClientBranch,
					nod:$event.nod,
					Collection:Collection
				})"

				v-on:callTool="$emit('callTool',{
					ClientBranch:$event.ClientBranch,
					tool:$event.tool,
					state:$event.state,
					Collection:Collection
				})"

				v-on:deleteClientBranch="$emit('deleteClientBranch',{
					Collection:Collection,
					...$event
				})"
				v-on:deleteNod="$emit('deleteNod',{
					Collection:Collection,
					ClientBranch:$event.ClientBranch,
					nod:$event.nod,
					tree:$event.tree
				})"
				v-on:dropEdits="$emit('dropEdits',$event)"

				v-on:editBBuffer="$emit('editBBuffer',$event)"

				v-on:hideBranch="$emit('hideBranch', $event)"

				v-on:moveBranch="$emit('moveBranch',{
					Collection:Collection,
					ClientBranch:$event.ClientBranch,
					direction:$event.direction
				})"

				v-on:overwriteQueryResponse="overwriteQueryResponse($event)"


				v-on:removeBranch="$emit('removeBranch',{
					Collection:Collection,
					ClientBranch:$event.ClientBranch
				})"

				v-on:scrollPos="displayScroll($event)"
				v-on:setClientBranchDisplay="setClientBranchDisplay({
					ClientBranch:$event.ClientBranch,
					display:$event.display
				})"
				v-on:setQueryRequest="setQueryRequest($event)"

				v-on:toggleChildVis="toggleChildVis($event)"

				v-on:updateBranch="$emit('updateBranch',{
					ClientBranch:$event.ClientBranch,
					nod:$event.nod
				})"
				v-on:updateBranchAlias="$emit('updateBranchAlias', $event)"
				v-on:updateCBFilter="updateCBFilter({
					Collection:Collection,
					ClientBranch:$event.ClientBranch,
					Instance:$event.Instance,
				})"
				v-on:updateDigest="updateDigest($event)"
				v-on:refreshTrees="$emit('refreshTrees',$event)"
			/>

			<!-- Body - editITree -->
			<div class="editInstance-div"
				v-if="Collection.rootInstanceID !== '' && Array.isArray(Collection.editITree.ITrees)"
			>
				<div v-for="(ITree) in Collection.editITree.ITrees"
					v-bind:key="ITree.ID">
					<InstanceView
						class="instance"
						v-bind:style="{
							'background-color':'#fcd4d4',
							'left': '-' + (displayVars.filterWidth + 10) + 'px'
						}"
						v-bind:key="ITree.ID"
						v-bind:authStatus="authStatus"
						v-bind:ITree="ITree"
						v-bind:tableWidth="instanceTableWidth(ITree)"
						v-bind:enableEdit="true"
						v-bind:showHiddenBranches="showHiddenBranches"
						v-bind:editMode="3"
						v-bind:activeChild="activeChild"
						v-bind:forModal="Collection.isModal"
						v-bind:rootInstanceID="Collection.rootInstanceID"

						v-on:activateChild="$emit('activateChild',$event)"
						v-on:callInstanceMutation="callInstanceMutation($event)"
						v-on:callModalCollection="callModalCollection($event)"
						v-on:clientInstanceRequest="handleClientInstanceRequest($event)"
						v-on:clientInstanceResponse="clientInstanceResponse($event)"
						v-on:clientInstanceDisplay="$emit('clientInstanceDisplay', $event)"
						v-on:editBuffer="$emit('editBuffer',$event)"
						v-on:newIBranch="newIBranch($event)"
						v-on:parentFilterCheck="parentFilterCheck($event)"
						v-on:removeOrphanFilter="removeOrphanFilter($event)"
						v-on:selectITree="selectITree($event)"
						v-on:setActiveRequest="$emit('setActiveRequest',$event)"
						v-on:setEditMode="setEditMode($event)"
						v-on:updateCBFilter="updateCBFilter({
							Collection:Collection,
							ClientBranch:$event.ClientBranch,
							Instance:$event.Instance
						})"
						v-on:updateInstance="updateInstance($event)"
					/>
					<!-- <div class="instance-spacer">&nbsp;</div> -->
				</div>
			</div>

			<!-- Body - ITrees -->
			<div class="instances-div"
				id="h-scroll-3"
				ref="h_scroll_3"
				v-on:scroll.passive="handleScroll($event)"
				v-if="Collection.editMode > 0 && Collection.ITrees.ITrees.length"
			>
				<div class="instance" v-for="(ITree, index) in visibleInstances"
					v-bind:key="ITree.ID"
					v-bind:style="index === visibleInstances.length - 1 ? { paddingRight: '5px' } : { paddingRight: '5px' }"
				>
					<InstanceView
						class="instance"
						v-bind:activeChild="activeChild"
						v-bind:authStatus="authStatus"
						v-bind:clickToFilter="Collection.flags.clickToFilter"
						v-bind:editMode="2"
						v-bind:enableEdit="false"
						v-bind:showHiddenBranches="showHiddenBranches"
						v-bind:forModal="Collection.isModal"
						v-bind:ITree="ITree"
						v-bind:tableWidth="instanceTableWidth(ITree)"
						v-bind:key="ITree.ID"
						v-bind:rootInstanceID="Collection.rootInstanceID"

						v-on:activateChild="$emit('activateChild',$event)"
						v-on:setActiveRequest="$emit('setActiveRequest',$event)"
						v-on:callInstanceMutation="callInstanceMutation($event)"
						v-on:callModalCollection="callModalCollection($event)"
						v-on:clientInstanceResponse="clientInstanceResponse($event)"
						v-on:editBuffer="$emit('editBuffer',$event)"
						v-on:clientInstanceRequest="handleClientInstanceRequest($event)"
						v-on:clientInstanceDisplay="$emit('clientInstanceDisplay', $event)"
						v-on:findTargetInstance="findTargetInstance($event)"
						v-on:newIBranch="newIBranch($event)"
						v-on:parentFilterCheck="parentFilterCheck($event)"
						v-on:removeOrphanFilter="removeOrphanFilter($event)"
						v-on:selectITree="selectITree($event)"
						v-on:setEditMode="setEditMode($event)"
						v-on:updateCBFilter="updateCBFilter({
							Collection:Collection,
							ClientBranch:$event.ClientBranch,
							Instance:$event.Instance,
						})"
						v-on:updateInstance="updateInstance($event)"
						v-on:open-viewer="handleOpenViewer"
						ref="instanceViews"
					/>
				</div>
			</div>
		</div>

		<!-- Images -->
			<ImageViewer
				v-if="isImageViewerOpen && currentViewerImageUrl"
				:imageUrl="currentViewerImageUrl"
				:currentViewerITreeID="currentViewerITreeID"
				:orderedTree="orderedTree"
				:orderedInstances="visibleInstances"
				@close="isImageViewerOpen = false"
				@prev="cycleImage(-1)"
				@next="cycleImage(1)"
			/>
	</div>
</template>


<script>
	import _ from 'lodash'
	import {cache, client} from '../main.js'
	import { v7 as uuidv7 } from 'uuid';

	import Autocomplete from './AutoComplete.vue'
	import BranchButtons from './BranchButtons.vue'
	import editMode from '../graphql/client/Collection/editModeFragment.gql'
	import SelectionFragment from '../graphql/client/Collection/SelectionFragment.gql'
	import getBranch from '../graphql/server/Branch/Branch.gql'
	import getICollection from '../graphql/server/ICollection/ICollection.gql'
	import getICollections from '../graphql/server/ICollection/ICollections.gql'
	import getGroups from '../graphql/server/Groups/getGroups.gql'
	import CreateGroupMutation from '../graphql/server/Groups/CreateGroup.gql'
	import AddToGroupMutation from '../graphql/server/Groups/AddToGroup.gql'
	import RemoveFromGroupMutation from '../graphql/server/Groups/RemoveFromGroup.gql'
	import InstanceView from './InstanceView.vue'
	import isVisible from '../graphql/client/ClientBranch/isVisibleFragment.gql'
	import displayFragment from   '../graphql/client/ClientBranch/displayFragment.gql'
	import displayImages from '../graphql/client/ITree/displayImagesFragment.gql'
	import QueryButton from './QueryButton.vue'
	import setFilter from '../graphql/client/ClientBranch/setFilterFragment.gql'
	import showChildren from '../graphql/client/ClientBranch/showChildrenFragment.gql'
	import TreeTable from './TreeTable.vue'
	import UpdateDigestMutation from '../graphql/server/Branch/UpdateDigestMutation.gql'
	import ImageViewer from './ImageViewer.vue'

	export default {
		name: 'CollectionView',
		components:{
			Autocomplete,
			BranchButtons,
			InstanceView,
			QueryButton,
			TreeTable,
			ImageViewer,
		},
		props: {
			activeChild:{
				type:Boolean,
				required: true
			},
			authStatus:{
				type:Object,
				required: true
			},
			activeRequest:{
				type:Boolean,
				required: true
			},
			Collection:{
				type: Object,
				required: false,
			},
			pauseICollections:{
				type:Boolean,
				required: true
			},
			queries:{
				type:Array,
				required:false
			},
			windowWidth:{
				type:Number,
				required:true
			},
		},
		data() {
			return {
				username: '',
				applyFilters: false,
				Branches:[],
				enableEdit: true,
				iCollections:[],
				iCollection:[],
				INSTANCE_MARGIN: 5,
				nodFilter:null,
				queryMoreRecords: true,
				queryLimit: 7,
				queryMode: 0,
				selectRoot: false,
				bodyMaxHeight: null,
				showHiddenBranches: false,
				isImageViewerOpen: false,
				currentViewerImageUrl: '',
				currentViewerITreeID: null,
				groups: [],
				group: '',
				groupMode: '0', // Track current group mode: '0' - none, 'D' - delete, 'C' - create, '-' - remove, '+' - add
				addMode: false, // Track if we're in "add to group" mode
				devExitEarly: false // Development flag to exit group methods early for testing
			}
		},
		apollo: {
			Branches:{
				query:getBranch,
				variables(){ return {root:this.Collection.Root.name}},
				fetchPolicy: 'cache-and-network'
			},
            iCollections:{
                query:getICollections,
                variables(){
                    return{
                        root:this.Collection.Root.ID,
                        skip: this.Collection.pageVars.offset,
                        limit: this.queryLimit,
                        applyFilters: this.Collection.useFilters?true:false,
                        filters: this.filters,
                        group: this.group
                    }
                },
                fetchPolicy: 'network-only',
                nextFetchPolicy: 'network-only',
                skip() {return (this.activeChild || this.Collection.editMode === 0 ) }
            },
			iCollection:{
				query:getICollection,
				variables(){
					return{
						root:this.Collection.Root.ID,
						rootInstanceID:this.Collection.rootInstanceID
					}
				},
				fetchPolicy: 'cache-and-network',
				skip() {return (this.activeChild || this.Collection.editMode === 0) }
			},
			Groups: {
				query: getGroups,
				variables() {
					return {
						userID: this.authStatus.userID,
						root: this.Collection.Root.ID || null
					};
				},
				skip() { return !this.authStatus.userID }
			}
		},
		methods: {
			updateBodyMaxHeight() {
				this.$nextTick(() => {
					if (!this.$el || !this.$el.parentElement) {
						return
					}
					const container = this.$el.parentElement
					const containerRect = container.getBoundingClientRect()
					const elementRect = this.$el.getBoundingClientRect()
					const containerStyles = window.getComputedStyle(container)
					const elementStyles = window.getComputedStyle(this.$el)
					const containerPaddingBottom = parseFloat(containerStyles.paddingBottom || '0')
					const elementMarginBottom = parseFloat(elementStyles.marginBottom || '0')
					const available = containerRect.bottom - elementRect.top - containerPaddingBottom - elementMarginBottom
					const nextHeight = available > 0 ? available : null
					if (this.bodyMaxHeight !== nextHeight) {
						this.bodyMaxHeight = nextHeight
					}
				})
			},
			activateClientInstance(ClientInstance,state){
				// console.log('activateClientInstance ' + state)
				this.$emit('clientInstanceIsActive',{ClientInstance:ClientInstance,state:state})
			},
			addTempClientBranch(vars){
				// console.log('addTempClientBranch')
				// send request from TreeTable to Cluster
				const {ClientBranch} = vars
				// add a ClientBranch with empty Branch.Child Nod
				const item = this.Collection.Tree.ClientBranches.filter(cB => ClientBranch.ID == cB.parentCB.ID).length +1
				// assemble the new temp ClientBranch
				const newClientBranch = {
					Branches:this.Branches,
					Branch:{
						Parent:ClientBranch.Branch.Child,
						ID:uuidv7(),
						item:item,//ClientBranch.childCount + 1,
						created:null,
						digest:null,
						isHidden: null,
						alias: null,
						Child:{
							__typename:"Nod",
							ID: uuidv7(),
							name:"",
							created:null,
							isCollection:null
						},
						__typename:"Branch"
					},
					parentClientBranch:ClientBranch,
					treeID:this.Collection.Tree.ID
				}
				// emit it to parent
				this.$emit('addClientBranch',newClientBranch)
			},
			callFilterTools(){
				// this.$emit('activateChild',true)
				this.showFilterTools = true
			},
			findTargetInstance(vars){
				// console.log('findTargetInstance:', vars)
				// you clicked on an Instance child when clicktofilter points to the editITree Object
				const {Branch, Instance} = vars
				const ClientInstance = this.Collection.editITree.ITrees[0].ClientInstances.find(cI => cI.ClientBranch.Branch.ID == Branch.ID)
				// check to see if there is already a value there
				const hasValue = ClientInstance.iBranch?.Child?.value?true:false
				// const unSaved = ClientInstance.iBranch?true:false
				if (!hasValue){
					// should point to clientInstanceRequest
					// { ClientInstance, action, Instance, item }
					// const Collection = this.Collection
					const action = 'addExistingInstance'
					const requestVars = {
						ClientInstance:ClientInstance,
						action: action,
						Instance:Instance
					}
					console.log('findTargetInstance:', requestVars)
					this.$emit('activateChild', true)
					this.$emit('clientInstanceRequest', requestVars)
					// this.$emit('callInstanceMutation',mutationVars)
					// this.$emit('activateChild',true)
				}
			},
			callInstanceMutation(vars){
				// add Collection.ID to vars object as it passes through this collection
				vars.CollectionID = this.Collection.ID
				console.log('callInstanceMutation', vars)
				this.$emit('callInstanceMutation',vars)
			},
			callModalCollection(vars){
				// console.log(vars)
				// add Collection.ID to vars object as it passes through this collection
				vars.parentCollectionID = this.Collection.ID
				this.$emit('callModalCollection',vars)
			},
			clientInstanceResponse(vars){
				vars.CollectionID = this.Collection.ID
				this.$emit('clientInstanceResponse',vars)
			},
			handleClientInstanceRequest(vars){
				this.$emit('activateChild', true)
				this.$emit('clientInstanceRequest', vars)
			},
			deleteInstance(ClientInstance){
				const Instance = ClientInstance.iBranch.Child
				const iVars = {
					ClientInstance:ClientInstance,
					request:{
						buttons:['Y','N'],
						Instance:{
							ID:Instance.ID,
							value:Instance.value,
							isPinned:Instance.isPinned?Instance.isPinned:false,
							isFilter:Instance.isFilter,
							created:Instance.created,
							__typename:Instance.__typename
						},
						mode:'deleteInstance',
						req:'Delete this ' +  ClientInstance.ClientBranch.Branch.Child.name + '?',
					}
				}
				this.$emit('clientInstanceRequest',iVars)
				this.activateClientInstance(ClientInstance,false)
			},
			disableQueryButtons(mode){
				const activeChild =  this.activeChild
				if(mode == 0){return activeChild}
				if(mode == 1){return activeChild || this.orderedQueries.length == 0}
				if(mode == 2){return activeChild || this.orderedQueries.filter(q => q.RootInstance.isPinned).length == this.orderedQueries.length}
			},
			doneEdit(){
				// console.log('doneEdit')
				this.setRootInstanceID('')
				this.$emit('toggleClickToFilter',{Collection:this.Collection,state:true})
				// this.$emit('createITrees',{
				// 	Tree:this.Collection.Tree,
				// 	iCollections:[],
				// 	iTreesID:this.Collection.editITree.ID
				// })
			},
			dropChanges(){
				this.$emit('activateChild',false)
				this.selectRoot = false // this element is active
			},
			editExistingInstance(ITree){
				this.$emit('setActiveRequest',false)
				this.setRootInstanceID(ITree.ClientInstances[0].iBranch.Child.ID)
			},
			// PAGINATION limit getMore function calls to 1 every 250 ms
			fetchMore:_.throttle(function(){this.getMore(this.Collection.pageVars,this.iCollections)},500),
				getMore(){
					// console.log('getMore')
					const limit = this.queryLimit
					const currentCount = this.iCollections.length
					const endCursor = this.iCollections.pageInfo?.endCursor || ""

					// Improved logic: only fetch more if we have pagination info and can fetch more
					if(this.iCollections.pageInfo?.hasNextPage) {
						this.$apollo.queries.iCollections.fetchMore({
							variables: {
								cursor: endCursor,  // Use the end cursor for pagination
							},
							// Add the new data to the previous result
							updateQuery: (previousResult, { fetchMoreResult }) => {
								// Only update if we actually got more results
								if (fetchMoreResult && fetchMoreResult.iCollections?.edges && fetchMoreResult.iCollections.edges.length > 0) {
									// Check if this fetch returned a full page
									const isFullPage = fetchMoreResult.iCollections.edges.length === limit

									// Update the collections
									const updatedCollections = {
										...fetchMoreResult.iCollections,
										edges: [...previousResult.iCollections.edges, ...fetchMoreResult.iCollections.edges]
									}

									// If this wasn't a full page, we've reached the end
									if (!isFullPage) {
										updatedCollections.pageInfo = {
											...updatedCollections.pageInfo,
											hasNextPage: false
										}
										console.log('Reached end of results')
									}

									return {iCollections: updatedCollections}
								}
								return previousResult
							},
						})
						.then(() => {
							// Update the cursor in the collection page vars
							if (this.iCollections.edges.length > currentCount) {
								this.$emit('pageCounter', {
									Collection: this.Collection,
									cursor: this.iCollections.paginationInfo.endCursor
								})
							}
							this.queryMoreRecords = true;
						})
					} else {
						this.queryMoreRecords = false
						// If we're not fetching, it means we've reached the end
						// console.log('Not fetching more - reached end of results')
					}
			},
			handleQueryTool(vars){
				// console.log('handleQueryTool ', vars)
				// actually it's for handling filters too
				const tree = this.Collection.Tree.ClientBranches
				// const useFilters = this.Collection.useFilters
				let {branchToolCode} = vars
				switch ( branchToolCode ){
					case 'X': // Cancel
					break
					case 'S': // Save
						{
							this.$emit('addQuery',{collection:this.Collection})
						}
					break
					case 'F': // Toggle Filters
						// ALWAYS reset page counter when toggling filters
						this.$emit('pageCounter', {Collection: this.Collection, offset: 0});

						// Toggle the filter state
						this.$emit('setUseFilters', {Collection: this.Collection, state: !this.Collection.useFilters});

						// Force refetch with new filter state
						this.$nextTick(() => {
							if (this.$apollo.queries.iCollections) {
								this.$apollo.queries.iCollections.refetch();
							}
						});
					break
					case 'R': // Remove
						{
							const cB = tree.filter(t=>!_.isEmpty(t.filter))  // ClientBranches that have filters
							// clear the active query so button is not highlighted
							this.$emit('setActiveQuery',({Collection:this.Collection,query:''}))
							// remove all filters
							cB.map(cB=> this.updateCBFilter({
								ClientBranch:cB,
								Instance:{Instance:{},request:''}}))
						}
					break
					case 'N': // NickName
						{this.addAlias = true}
					break
				}
				this.showFilterTools = false
				this.$emit('activateChild',false)
			},
			handleRootSelection(selection){
				// console.log('handleRootSelection - ', selection)
				if(selection.code == 2){
					// a new root was selected from the <InstanceAutocomplete> component
					const vars = {
						Collection:this.Collection,
						code:selection.code,
						rootNod:selection.item,
						query:{}
					}
					this.$emit('setRoot',vars)
				}
				this.selectRoot = false
				this.$emit('activateChild',false)
			},
			handleScroll (e) {
				// console.log('handleScroll')
				// syncronise scrolling between the h-scroll divs
				if (this.Collection.ITrees.ITrees){
					var div1 = this.$refs.h_scroll_1
					var div2 = this.$refs.h_scroll_2
					var div3 = this.$refs.h_scroll_3
					// getMore Instances if scroll position is within 50 px of the end if there are more items available
					if (e.target.id=="h-scroll-1") {
						div2.scrollLeft = div1.scrollLeft
						// div3 will not exist if top level of tree is collapsed so check for this
						if(div3){div3.scrollLeft = div1.scrollLeft}
					}
					if (e.target.id=="h-scroll-2") {
						div1.scrollLeft = div2.scrollLeft
						// div3 will not exist if top level of tree is collapsed so check for this
						if(div3){div3.scrollLeft = div2.scrollLeft}
					}
					if (e.target.id=="h-scroll-3") {
						div1.scrollLeft = div3.scrollLeft
						div2.scrollLeft = div3.scrollLeft
					}
					// handleScroll will be called by each of the three h-scroll divs which will result in a lot of calls
					// so limit calling of getMore to h-scroll-1 only
					if (
						e.target.id=="h-scroll-1" &&
						// when scroll position nears the right end ...
						(div1.scrollWidth - div1.scrollLeft - this.displayVars.instancesWindow) < 100 &&
						// Fixed: check if we have enough items to potentially need more
						this.iCollections.length >= this.queryLimit
					){
						// so fetch some more
						this.fetchMore()
					}
				}
			},
			instanceTableWidth(Instance){
				const match = this.displayVars.instanceWidths.find(i => i.ID == Instance.ID)
				return match.width
			},
			overwriteQueryResponse(response){
				this.setQueryRequest({req:'',buttons:[]})
				if(response == 'Y'){
					this.$emit('addQuery',{overWrite: true, collection:this.Collection})
				}
			},
			queryHandler(vars){
				const {rootNod, query, Op} = vars
				// console.log('queryHandler-collection -', vars)
				// runs for selections made within a collection
				// this.setEditMode(2)
				// punch up to Cluster
				this.$emit('queryHandler',{
					Collection:this.Collection,
					rootNod:rootNod,
					query:query,
					Op:Op
				})
				this.queryMode = 0
			},
			removeCollection(){
				// emit the Collection object to the parent
				this.$emit('removeCollection',{CollectionID:this.Collection.ID,refresh:false})
			},
			removeOrphanFilter(filterVars){
				const{ClientInstance,Instance} = filterVars
				// after deleting an orphan, check to see if the Instance
				// is used as a filter for this ClientBranch
				const isFilter = ClientInstance.ClientBranch.filter.ID == Instance.ID
				if (isFilter){
					const filterVars = {
						Collection: this.Collection,
						ClientBranch:ClientInstance.ClientBranch,
						Instance: {},
					}
					this.updateCBFilter(filterVars)
				}
				// in all cases, deleted if from the cache
				const ID = 'Instance:{"ID":"' + Instance.ID + '"}'
				cache.evict({id: ID})
			},
			scrollInstances(direction){
				if(this.visibleInstances.length >0){
					// console.log('Scroll ' + direction)
					var div1 = this.$refs.h_scroll_1
					const currentPos =div1.scrollLeft
					const step = this.displayVars.instancesWindow
					const offset = direction == '+'?step:-step
					const newPos = currentPos + offset
					div1.scrollLeft = newPos
					if (direction == '+' ){
						this.fetchMore() // Use the throttled fetchMore function instead of direct getMore call
					}
				}
			},
			selectCollection(){
				// console.log('selectCollection - ')
				// changing these states causes the autoComplete component to display
				// so a Collection can be chosen
				if(!this.Collection.activeChild){
					this.selectRoot = true // this element is active
					this.$emit('activateChild',true) // this component or a child has an active element
				}else{
					this.$emit('activateChild',false)
				}
			},
			selectITree(ITree){
				// console.log('selectITree' , ITree.ID)
				const newSelectedState = !ITree.isSelected
				client.cache.modify({
					id: client.cache.identify(ITree),
					fields: {
						isSelected() { return newSelectedState }
					}
				})
				// Update persistent selection storage
				this.updatePersistentSelection({instanceID:ITree.ClientInstances[0].iBranch.Child.ID, state:newSelectedState})
			},
			updatePersistentSelection(vars) {
				const{ instanceID, state } = vars
				// console.log('updatePersistentSelection' , state)
				const currentSelections = this.Collection.selectedInstanceIDs || []
				let newSelections = [...currentSelections]

				if (state) {
					// Add to selection if not already present
					if (!newSelections.includes(instanceID)) {
						newSelections.push(instanceID)
					}
				} else {
					// Remove from selection
					newSelections = newSelections.filter(id => id !== instanceID)
				}
				const ID = 'Collection:{"ID":"' + this.Collection.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: SelectionFragment,
					fragmentName: 'SelectionFragment',
					data: {selectedInstanceIDs: newSelections},
				})
			},
			// restoreSelections(ITrees) {
			// 	// Restore selection state from persistent storage
			// 	const selectedInstanceIDs = this.Collection.selectedInstanceIDs || []
				
			// 	ITrees.forEach(iTree => {
			// 		const instanceID = iTree.ClientInstances[0].iBranch.Child.ID
			// 		const isSelected = selectedInstanceIDs.includes(instanceID)
					
			// 		// Update ITree selection state if it has changed
			// 		if (iTree.isSelected !== isSelected) {
			// 			client.writeFragment({
			// 				id: client.cache.identify(iTree),
			// 				fragment: isSelected,
			// 				fragmentName: 'isSelected',
			// 				data: {isSelected: isSelected},
			// 			})
			// 		}
			// 	})
			// },
			setClientBranchDisplay(vars){
				// console.log('setClientBranchDisplay ', vars)
				const { ClientBranch, display } = vars
				const ID = client.cache.identify(ClientBranch);
				client.writeFragment({
					id: ID,
					fragment: displayFragment,
					fragmentName: 'displayFragment',
					data: {display: display}
				})
			},
			setEditMode(){
				// console.log('setEditMode -', this.Collection.editMode)
				if (!this.authStatus.isAdmin && this.Collection.editMode === 0) return

				const mode = this.Collection.editMode?0:2
				var ID = 'Collection:{"ID":"' + this.Collection.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: editMode,
					fragmentName: 'editMode',
					data: {editMode: mode},
				})
				if (mode == 2){
					// console.log('setEditMode -', this.Collection.editMode)
					// this.$emit('refreshTrees')
				}
				// this.$emit('setPauseICollections',mode)
			},
			setQueryRequest(Vars){
				const {req,buttons} = Vars
				// this will be called from saveQuery when the query name already exists
				const ClientBranch = this.Collection.Tree.ClientBranches[0]
				const vars = {
					buffer:'',
					Instance:ClientBranch.filter.Instance,
					request:req,
					buttons:buttons
				}
				client.writeFragment({
					id: client.cache.identify(ClientBranch),
					fragment: setFilter,
					fragmentName: 'setFilter',
					data: {filter:vars}
				})
			},
			setRootInstanceID(rootID){
				// console.log('setRootInstanceID ' + rootID)
				// this.$emit('setActiveRequest',true)
				this.$emit('setRootInstanceID',{CollectionID:this.Collection.ID,rootID:rootID})
			},
			displayImages(ITree){
				event.preventDefault()
				if(!ITree.displayImages){
					// console.log ('displayImages -', ITree)
				}
				client.writeFragment({
					id: client.cache.identify(ITree),
					fragment: displayImages,
					fragmentName: 'displayImages',
					data: {displayImages: !ITree.displayImages},// toggle current state
				})
			},
			toggleChildVis(ClientBranch){// invert the visibility of all descendants in this branch
				// console.log("toggleChildVis -", ClientBranch)
				const newVis = !ClientBranch.showChildren
				let ID = 'ClientBranch:{"ID":"' + ClientBranch.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: showChildren,
					fragmentName: 'showChildren',
					data: {showChildren: newVis}
				})
				// repeat this for all children of the branch
				this.toggleChildren(client,ClientBranch,newVis)
			},
			toggleChildren(client,ClientBranch,vis) {// set the visibility of all children of branch
				// console.log("toggleChildren -", ClientBranch, vis)
				let path = ClientBranch.path // all child paths will begin with the path of this branch
				let length = path.length
				// find all the children
				let children = this.Collection.Tree.ClientBranches.filter(tree =>
					tree.path.substring(0,length) == path // all paths that match ClientBranch.path
					&&
					tree.path.length == length + 4 // and tree.path length is one level > path
				)
				// iterate through each child
				children.forEach(child =>{
					// set the visibility of each child
					this.toggleBranch(client,child,vis)
					// set the visibility of the children
					// only when showChidren is true
					if(child.showChildren){
						this.toggleChildren(client,child,vis)
					}
				})
			},
			toggleBranch(client,ClientBranch,vis){// set the visibility of a branch
				// set ClientBranch:isVisible
				let ID = 'ClientBranch:{"ID":"' + ClientBranch.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: isVisible,
					fragmentName: 'isVisible',
					data: {isVisible: vis},
				})
			},
			toggleShowHidden(state){
				this.showHiddenBranches = Boolean(state)
			},
			updateDigest(vars){
				this.$apollo.mutate({
					mutation: UpdateDigestMutation,
					variables: {branchInput: vars}
				})
				.then (()=>{
				})
				.catch(error=>{
					console.log('Update Digest Error: ' + error)
				})
			},

			// Group Controls
			deleteGroup(){
				console.log('deleteGroup')
			},
			createGroup() {
				console.log('createGroup')
				if (this.activeChild) return;
				if (this.devExitEarly){return}

				// Get the selected instances from the current collection
				const selectedInstances = this.visibleInstances.filter(iT => iT.isSelected);
				if (selectedInstances.length === 0) {
					alert('Please select at least one instance to add to the group.');
					return;
				}
				console.log('selectedInstances: ' , selectedInstances)
				// Get root instance IDs from selected instances
				const rootInstanceIDs = selectedInstances.map(iT => iT.ClientInstances[0].iBranch.Child.ID);

				// Prompt user for group name
				const groupName = prompt('Enter a name for the new group:');
				if (!groupName || groupName.trim() === '') {
					alert('Group name cannot be empty.');
					return;
				}

				// Create the group
				this.$apollo.mutate({
					mutation: CreateGroupMutation,
					variables: {
						userID: this.authStatus.userID,
						name: groupName,
						rootInstanceIDs: rootInstanceIDs
					}
				})
				.then(result => {
					console.log('Group created:', result.data.CreateGroup);
					// Refresh the groups query to show the new group
					this.$apollo.queries.Groups.refetch();
					// Optionally select the new group
					this.group = result.data.CreateGroup.ID;
					// Clear ALL selections after creating group
					this.Collection.ITrees.ITrees.forEach(iT => {
						if (iT.isSelected) {
							this.selectITree(iT);
						}
					});
				})
				.catch(error => {
					console.error('Error creating group:', error);
					alert('Error creating group. See console for details.');
				});
			},
			// Remove selected instances from the currently selected group
			removeFromGroup() {
				console.log('removeFromGroup')
				if (this.activeChild || !this.group) return;
				this.groupMode == '0'? this.groupMode = '-': this.groupMode = '0'

				if(this.devExitEarly){return}

				// Get selected instances
				const selectedInstances = this.visibleInstances.filter(iT => iT.isSelected);
				if (selectedInstances.length === 0) {
					alert('Please select at least one instance to remove from the group.');
					return;
				}

				// Get root instance IDs from selected instances
				const rootInstanceIDs = selectedInstances.map(iT => iT.ClientInstances[0].iBranch.Child.ID);

				// Confirm with user
				const groupName = this.Groups.find(g => g.ID === this.group)?.name || 'this group';
				const confirmMessage = `Remove ${rootInstanceIDs.length} instance(s) from ${groupName}?`;

				if (confirm(confirmMessage)) {
					// Call RemoveFromGroup mutation
					this.$apollo.mutate({
						mutation: RemoveFromGroupMutation,
						variables: {
							groupID: this.group,
							rootInstanceIDs: rootInstanceIDs
						},
						// Update the cache after mutation
						update: (cache, { data: { RemoveFromGroup } }) => {
							try {
								console.log('RemoveFromGroup mutation result:', RemoveFromGroup);
								console.log('Current group ID:', this.group);
								console.log('Auth status:', this.authStatus.userID);
								console.log('Collection root:', this.Collection.Root.ID);

								// Read the current groups from cache
								const cacheData = cache.readQuery({
									query: getGroups,
									variables: {
										userID: this.authStatus.userID,
										root: this.Collection.Root.ID || null
									}
								});

								console.log('Cache data before update:', cacheData);

								if (cacheData && cacheData.Groups) {
									// Update the specific group in the cache with the new data from mutation
									const updatedGroups = cacheData.Groups.map(g => {
										if (g.ID === this.group) {
											console.log('Found matching group to update:', g.ID);
											console.log('Old rootInstanceIDs:', g.rootInstanceIDs);
											console.log('New rootInstanceIDs from mutation:', RemoveFromGroup.rootInstanceIDs || []);

											// Calculate remaining instances by removing the deleted ones from current instances
											const remainingInstanceIDs = g.rootInstanceIDs.filter(id => !rootInstanceIDs.includes(id));
											console.log('Calculated remaining rootInstanceIDs:', remainingInstanceIDs);

											// Use the calculated remaining instances
											return {
												...g,
												rootInstanceIDs: remainingInstanceIDs
											};
										}
										return g;
									});

									console.log('Updated groups:', updatedGroups);

									// Write the updated data back to cache
									cache.writeQuery({
										query: getGroups,
										variables: {
											userID: this.authStatus.userID,
											root: this.Collection.Root.ID || null
										},
										data: { Groups: updatedGroups }
									});

									console.log('Cache update completed successfully');
								} else {
									console.log('No cache data found or no Groups in cache');
								}
							} catch (error) {
								console.error('Cache update error:', error);
								// Fallback to refetch if cache update fails
								console.log('Falling back to refetch...');
								this.$apollo.queries.Groups.refetch();
							}
						}
					})
					.then(result => {
						console.log('Removed from group:', result.data.RemoveFromGroup);
						// Refresh iCollections query to update instances in UI
						this.$apollo.queries.iCollections.refetch();
						// Clear selections
						selectedInstances.forEach(iT => this.selectITree(iT));
					})
					.catch(error => {
						console.error('Error removing from group:', error);
						alert('Error removing from group. See console for details.');
					});
				}
			},
			// Toggle group selection (radio button behavior)
			toggleGroupSelection(groupID) {
				if (this.group === groupID) {
					// Deselect if already selected (toggle behavior)
					this.group = '';
				} else {
					// Select the clicked group
					this.group = groupID;
				}
			},
			// Add selected instances to a group (no group should be active)
			addToGroup() {
				console.log('addToGroup')
				if (this.activeChild) return;
				if (this.devExitEarly){return}

				// Check if any group is currently active
				if (this.group) {
					alert('Please deselect the current group before adding instances to a group.');
					return;
				}

				// Get selected instances
				const selectedInstances = this.visibleInstances.filter(iT => iT.isSelected);
				if (selectedInstances.length === 0) {
					alert('Please select at least one instance to add to a group.');
					return;
				}

				// Enter "add mode" - clicking a group button will add instances directly
				this.addMode = true;
				alert(`Select a group to add ${selectedInstances.length} instances to.`);
			},
			// Directly add instances to the specified group (called when clicking group button in addMode)
			addToGroupDirect(groupID) {
				console.log('addToGroup')
				// Get selected instances
				const selectedInstances = this.visibleInstances.filter(iT => iT.isSelected);
				if (selectedInstances.length === 0) {
					alert('No instances selected to add to group.');
					this.addMode = false;
					return;
				}

				// Get root instance IDs from selected instances
				const rootInstanceIDs = selectedInstances.map(iT => iT.ClientInstances[0].iBranch.Child.ID);

				// Find the selected group
				const selectedGroup = this.Groups.find(g => g.ID === groupID);
				if (!selectedGroup) {
					alert('Group not found.');
					this.addMode = false;
					return;
				}

				// Confirm with user
				const confirmMessage = `Add ${rootInstanceIDs.length} instance(s) to ${selectedGroup.name}?`;

				if (confirm(confirmMessage)) {
					// Call AddToGroup mutation
					this.$apollo.mutate({
						mutation: AddToGroupMutation,
						variables: {
							groupID: selectedGroup.ID,
							rootInstanceIDs: rootInstanceIDs
						}
					})
					.then(result => {
						console.log('Added to group:', result.data.AddToGroup);
						// Refresh the groups query to update the instance counts
						this.$apollo.queries.Groups.refetch();
						// Clear selections and exit add mode
						selectedInstances.forEach(iT => this.selectITree(iT));
						this.addMode = false;
					})
					.catch(error => {
						console.error('Error adding to group:', error);
						alert('Error adding to group. See console for details.');
						this.addMode = false;
					});
				} else {
					// User cancelled, exit add mode
					this.addMode = false;
				}
			},


			updateCBFilter(vars){
				// edit a filter line item
				// console.log('Collection - updateCBFilter -', vars)
				const { ClientBranch, Instance } = vars
				const isRoot = ClientBranch.path == '001'  // this is the root so query will not be saved if it is empty
				const filterIsEmpty = _.isEmpty(Instance)
				// if level is greater than 2 then look for a parent Instance
				// if removing the root filter then set Collection.flags.activeQuery == ''
				if( isRoot && filterIsEmpty ){
					this.$emit('setActiveQuery',({
						Collection:this.Collection,
						ClientBranch: ClientBranch,
						query: {}
					}))
				}
				// console.log(vars)
				// apply selected Instance to a Filter
				this.$emit('updateCBFilter',vars)

			},
			syncBodyScroll(event) {
				const scrollTop = event?.target?.scrollTop || 0
				this.$emit('scrollSynced', { scrollTop, collectionID: this.Collection.ID })
			},
			handleOpenViewer(payload) {
				this.currentViewerITreeID = payload.ITreeID;
				this.currentViewerImageUrl = payload.imageUrl;
				this.isImageViewerOpen = true;
			},
			async cycleImage(direction) {
				const allTrees = this.Collection.ITrees.ITrees;
				if (!allTrees || allTrees.length === 0) return;

				const currentIndex = allTrees.findIndex(t => t.ID === this.currentViewerITreeID);
				if (currentIndex === -1) return;

				let nextIndex = currentIndex + direction;
				while (nextIndex >= 0 && nextIndex < allTrees.length) {
					const nextTree = allTrees[nextIndex];

					// See if nextTree has an image Nod
					const imageCI = (nextTree.ClientInstances || []).find(cI =>
						cI?.ClientBranch?.Branch?.Child?.ID === '37da8b91-bff2-4455-b533-f4d4fa5e4db4'
					);

					if (imageCI && imageCI.iBranch && imageCI.iBranch.Child && imageCI.iBranch.Child.value) {
						const compositeKey = imageCI.iBranch.Child.value;
						const imageKey = compositeKey.includes('|') ? compositeKey.split('|')[1] : compositeKey;

						if (/\.(jpe?g|png|gif|bmp|webp|tiff?)$/i.test(imageKey)) {
							// Found an image! Fetch the URL.
							try {
								const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
								const baseUrl = process.env.VUE_APP_GRAPHQL_URL.replace('/graphql', '');
								const hash = imageKey.split('.')[0];

								const response = await fetch(`${baseUrl}/api/file/${hash}`, {
									headers: {
										'Authorization': `Bearer ${token}`
									}
								});

								if (response.ok) {
									const blob = await response.blob();
									const reader = new FileReader();
									reader.onloadend = () => {
										this.currentViewerITreeID = nextTree.ID;
										this.currentViewerImageUrl = reader.result;
									};
									reader.readAsDataURL(blob);
									return;
								}
							} catch (err) {
								console.error('Failed to load next image:', err);
							}
						}
					}
					nextIndex += direction;
				}
			},
		},
		watch:{
			Branches: {
				handler(newBranches, oldBranches) {
					const newIds = newBranches?.map(b => b.ID).sort().join(',');
					const oldIds = oldBranches?.map(b => b.ID).sort().join(',');
					if (newIds !== oldIds ) {
						// console.log('Branches Changed')
						const isInitial = !oldBranches || oldBranches.length === 0
						// Check if root has changed
						const hasRootChanged = this.Collection.Root !== this.previousRoot;
						this.previousRoot = this.Collection.Root;
						// If it's initial load or root has changed, we need full tree recreation
						const requiresFullRecreation = isInitial || hasRootChanged;
						const vars = {
							Collection: this.Collection,
							root: this.Collection.Root,
							Branches: newBranches,
							query: this.Collection.flags.activeQuery,
							operation: requiresFullRecreation?'create':'update'
						};
						// console.log('Branches Watcher:vars-', vars)
						this.$emit('createTree', vars)
					}
				}
			},
			groups: {
				handler(newGroups) {
					console.log('Groups data updated:', {
						count: newGroups.length,
						groups: newGroups.map(g => ({ name: g.name, id: g.ID, instances: g.rootInstanceIDs?.length }))
					});
					console.log('Current collection context:', {
						rootID: this.Collection.Root.ID,
						rootName: this.Collection.Root.name,
						editMode: this.Collection.editMode
					});
				},
				deep: true
			},
			'Collection.Root.ID': {
				handler(newRootID, oldRootID) {
					if (newRootID !== oldRootID && newRootID && this.Collection.editMode > 0) {
						// console.log('Root ID changed, refreshing groups:', newRootID);
						// Reset the current group selection when root changes
						this.group = '';
						// Force refresh of Groups query with new root ID
						this.$apollo.queries.Groups.refetch();
					}
				},
				immediate: false
			},
			'Collection.activeRequest':{
				handler (mode) {
					// console.log('Watch Collection.activeRequest', mode)
					this.$emit('setActiveRequest',mode == 2?true:false)
				}
			},
			iCollection: {
				handler(newICollection){
					if (this.activeChild) return; // Prevent overwrite during active request
					// console.log('iCollection - ', newICollection)
					const newRootInstanceID = this.Collection.rootInstanceID
					var vars = {
						Tree:this.Collection.Tree,
						iTreesID:this.Collection.editITree.ID
					}
					// if this is a new instance then create an empty iCollections
					if (newRootInstanceID == 'create' ){
						// console.log('Create new iCollection')
						vars.iCollection = [{
							__typename:"iCollection",
							ID: uuidv7(),
							iBranches:[],
							RootInstance:{
								__typename:"Instance",
								created:null,
								ID: uuidv7(),
								isFilter:null,
								isPinned:false,
								value:null
							}
						}]
					}else{
						vars.iCollection = newICollection
					}
					this.$emit('createITrees', { ...vars, Collection: this.Collection })
					// this.$emit('setActiveRequest', false)
				},
			},
			iCollections: {
				handler(newICollections){
					if (this.activeChild) return; // Prevent overwrite during active request
					// console.log('iCollections -', newICollections)
					if (newICollections){
						const vars = {
							Tree:this.Collection.Tree,
							iCollections:newICollections,
							iTreesID:this.Collection.ITrees.ID
						}
						this.$emit('createITrees', { ...vars, Collection: this.Collection })
					}
				}
			},
		},
		computed:{
			bodyDivStyle() {
				if (!this.bodyMaxHeight) {
					return {}
				}
				return { maxHeight: `${this.bodyMaxHeight}px` }
			},
			treeID() {
				return `Tree:{"ID":"${this.Collection.Tree.ID}"}`;
			},
			activeQueryExists(){
				if(this.Collection.Tree.ClientBranches.length>0){
					const activeQueryName = this.Collection.Tree.ClientBranches[0].filter.Instance.value
					const activeQueryExists = this.queries?this.queries.find(q=> q.RootInstance.value == activeQueryName)?true:false:false
					return activeQueryExists
				}else{
					return false
				}
			},
			staleFilters() {
				const cb = this.Collection.Tree?.ClientBranches;
				const filterContents = []
				if (cb && cb.length > 0) {
					cb.forEach((item, index) => {
						const val = item.filter?.Instance?.value;
						const branchID = index === 0 ? 'ROOT' : item.Branch?.ID;
						if (index === 0) {
							filterContents.push({ branchID, value: val && val.trim() !== '' ? val : "" });
						} else {
							if (val && val.trim() !== '') {
								filterContents.push({ branchID, value: val });
							}
						}
					})
				}

				if (filterContents.length === 0 || filterContents[0].value === "") return false;

				// USE THE ACTIVE QUERY ID TO FIND THE MATCH
				const activeQuery = this.Collection?.flags?.activeQuery;
				// Use activeQuery directly if it has the data, otherwise look it up in the queries prop
				const matchingQuery = (activeQuery && activeQuery.RootInstance)
					? activeQuery
					: this.queries?.find(q => q.ID === activeQuery?.ID);

				// If no active query is loaded, it's stale if it has a name (New Query)
				if (!matchingQuery || !matchingQuery.RootInstance) return true;

				const queryContents = [
					{ branchID: 'ROOT', value: matchingQuery.RootInstance.value }
				];

				const rootInstanceID = matchingQuery.RootInstance.ID;
				if (matchingQuery.iBranches) {
					matchingQuery.iBranches.forEach(ib => {
						const val = ib.Child?.value;
						const branchID = ib.Branch?.ID;
						const isRootBranch = ib.Child?.ID === rootInstanceID;
						if (val && val.trim() !== '' && !isRootBranch) {
							queryContents.push({ branchID, value: val });
						}
					});
				}
				const sortedFilters = _.orderBy(filterContents, ['branchID'], ['asc']);
				const sortedQuery = _.orderBy(queryContents, ['branchID'], ['asc']);

				const isStale = !_.isEqual(sortedFilters, sortedQuery);

				// console.log('sortedFilters ', JSON.stringify(sortedFilters))
				// console.log('sortedQuery   ', JSON.stringify(sortedQuery))
				// console.log('isStale ', isStale)

				if (this.Collection.flags.queryIsStale !== isStale) {
					this.$emit('setQueryIsStale', { Collection: this.Collection, state: isStale });
				}

				return isStale;
			},
			banner(){
				switch (this.Collection.editMode){
					case 0:
						return 'Define'// + page + temp + error
					// break
					case 1:
						return 'Create'// +  page + temp + error
					// break
					case 2:
						return 'Search'// +  page + temp + error
					// break
					case 3:
						return 'Edit'
					default: return null
				}
			},
			displayVars:function (){
				// this.windowWidth = prop from Cluster
				// get all visible ClientBranches
				const ClientBranches = this.Collection.Tree.ClientBranches.filter(cb => cb.isVisible && !_.isEmpty(cb.Branch.Child))
				// all Branch names
				const names = []
				// number of ClientBranches * value of indent
				const indents = []
				// filter width
				const filters = []
				// accumulate names,indents,filers for each ClientBranch that is visible
				ClientBranches.forEach(B => { // Changed map to forEach since you're not returning anything
					names.push(B.Branch.Child.name);
					indents.push(B.indent);
					if (!_.isEmpty(B.filter?.Instance)) { // Added optional chaining here for safety
						filters.push(B.filter.Instance.value);
					}
				});
				// convert ch to px units - determined by experimentation
				const chTOpx = 8
				// max indentation
				const indent = ((Math.max(...indents)) * 10) + 17 // px

				// Filter out null/undefined values before mapping
				const validFilters = filters.filter(f => f != null);
				const filterWidthCalc = !_.isEmpty(validFilters) ? Math.max(...(validFilters.map(el => el.length))) * chTOpx + 25 : 0;

				// Filter out null/undefined values before mapping
				const validNames = names.filter(n => n != null);
				const nameLenCalc = !_.isEmpty(validNames) ? (Math.max(...(validNames.map(el => el.length))) * chTOpx) + indent : 0;

				// return minimum values
				const filterWidth = filterWidthCalc < 100 ? 100 : Math.round(filterWidthCalc)
				const treeWidth = nameLenCalc < 100 ? 100 : Math.round(nameLenCalc)

				// ITrees
				// array of instance.ID and table widths depending on instance visiblity
				let allInstances = 0
				// array for individual visible table widths
				const instanceWidths = []
				const filterSelection = this.Collection.flags.filterSelection
				this.Collection.ITrees.ITrees.forEach(iT => {
					// use only isVisible and isSelected is true then visibleClientInstances
					if(iT.isVisible && (filterSelection ? iT.isSelected : true)){
						const visibleClientInstances = iT.ClientInstances.filter(cI => {
							const hidden = cI.ClientBranch?.Branch?.isHidden === true
							if (hidden && !this.showHiddenBranches) {
								return false
							}
							return cI.ClientBranch.isVisible
						})
						const widthCandidates = visibleClientInstances.map(cI => {
							const isRoot = cI.ClientBranch.path === '001'
							const isCollapsedCollection = cI.ClientBranch.Branch.Child.isCollection && !cI.ClientBranch.showChildren
							if (isCollapsedCollection && isRoot) {
								// For a collapsed collection, the width is determined by the digest string.
								return this.$digestString(cI, iT.ClientInstances).length
							} else if (cI.iBranch && cI.iBranch.Child && cI.iBranch.Child.value) {
								// For a visible instance, the width is determined by its value.
								return cI.iBranch.Child.value.length
							}
							return 0
						})
						let width = Math.max(...widthCandidates, 0) * chTOpx;
						width = width<60?60:width  // column min width is 80
						instanceWidths.push({
							ID: iT.ID,
							width: width
						})
						allInstances += (width + this.INSTANCE_MARGIN)
					}
					// subtract 1 margin for last instance
					allInstances = allInstances - this.INSTANCE_MARGIN
				})

				// EditITree
				// the editInstance object  - not always present
				const editInstance = this.Collection.editITree.ITrees[0]
				// width of edit Instance
				var editInstanceWidth = 0
				// editInstance column if it exists
				if (editInstance){
					var width = Math.max(
						...editInstance.ClientInstances
							.filter(cI => {
								const hidden = cI.ClientBranch?.Branch?.isHidden === true
								if (hidden && !this.showHiddenBranches) {
									return false
								}
									return cI.ClientBranch.isVisible
								})
							.map(cI => {
							if (cI.iBranch.Child) {
								return cI.iBranch.Child.value ? cI.iBranch.Child.value.length : 0;
							} else {
							return 0;
							}
						})
					) * chTOpx;
					width = width < 80 ? 80 : width  // column min width is 80
					editInstanceWidth = width
					instanceWidths.push({
						ID:editInstance.ID,
						width:editInstanceWidth
					})
				}
				editInstanceWidth = editInstanceWidth + this.INSTANCE_MARGIN
				// assemble the results into an object
				const colWids = {
					treeWidth: treeWidth + 4,
					filterWidth: filterWidth,
					instancesWindow: this.windowWidth - (treeWidth + filterWidth + 55),
					totalInstancesWidth: allInstances + 120,
					editInstanceWidth: editInstanceWidth,
					instanceWidths:instanceWidths,
					instanceMargin: this.INSTANCE_MARGIN
				}
				return colWids
			},
			filters: function (){
				// displays the filter that is loaded in the 'Filters Column'
				if(!_.isEmpty(this.Collection.Tree.ClientBranches)){
					// console.log('filters')
					const cBranches = _.orderBy(this.Collection.Tree.ClientBranches,'path','desc')
					var filters = []
					cBranches.map(cB=>{
						if (!_.isEmpty(cB.filter.Instance) && cB.path !== '001'){
							filters.push({
								path:cB.path,
								childNodID: cB.Branch.Child.ID,
								filter:{
									ID:cB.filter.Instance.ID,
									isFilter:cB.filter.Instance.isFilter,
									value:cB.filter.Instance.value,
									isPinned:cB.filter.Instance.isPinned
								}
							})
						}
					})
					return _.orderBy(filters,'path','asc')
				}else{
					return []
				}
			},
			filterToolCfg: function(){
				// console.log('filterToolCfg')
				const Tree = this.Collection.Tree.ClientBranches
				const useFilters = this.Collection.useFilters?1:0
				const cfg = []
				// config for filter tool buttons
				// cfg array of arrays for each button
				// [delete, save, toggle filters]  buttons
				// [toolCode, cssClass, disable, state, img]  configuration
				if(!_.isEmpty(Tree)){
					// 1. Delete Logic: Enable if there are any active filter values to clear
					const hasActiveFilters = Tree.some(cB => !_.isEmpty(cB.filter.Instance?.value))

					// 2. Save Logic: Use the computed staleFilters
					const canSave = this.staleFilters

					// 3. Toggle Logic: Enable if there's at least one branch that can be filtered
					const canToggle = Tree.some(t => t.filter.Instance)

					cfg.push( ...[
						['X','R',hasActiveFilters,0,'Delete.png'],
						['S','S',canSave,0,'Save.png'],
						['F','F',canToggle,useFilters,'Filter.png']
					])
				}
				return cfg
			},
			headings(){
				// const limit = this.queryLimit
				// Access edges array from the new cursor-based structure
				const group = this.group == '' ? '' : '[G] ' + this.Groups.find(g => g.ID == this.group).name + ' - '
				const filters = this.Collection.useFilters && this.Collection.flags?.activeQuery?.RootInstance?.value
				? '[Q] ' + this.Collection.flags.activeQuery.RootInstance.value + ' - '  : '';
				const count = '[' + (this.iCollections?.edges?.length  || 0) + ']'
				const more = this.iCollections.pageInfo?.hasNextPage ? '...' : ''
				const collection = group + filters + count + more
				const shortCollection = count + more
				const ITrees = this.Collection.ITrees.ITrees
				const editITrees = this.Collection.editITree.ITrees
				const editITreeID =	_.isEmpty(editITrees)?'':editITrees[0].iCollectionID
				const editInstance = editITreeID=='' ? false : ITrees.find(iT => iT.iCollectionID == editITreeID)?true:false
				const create = this.Collection.rootInstanceID == 'create'?true:false
				const headings = {
					Collection: collection,
					shortCollection: shortCollection,
					editInstance: create ? 'Create' : editInstance?'Edit':'Edit'
				}
				return headings
			},
			iCollectionHasDuplicates: function (){
				// Access edges array from the new cursor-based structure
				const iCollections = this.iCollections?.edges || []
				const allIDsArr = []
				iCollections.map(iC => allIDsArr.push(iC.ID))
				const allIDsSet = [...new Set(allIDsArr)]
				return allIDsArr.length == allIDsSet.length?false:true
			},
			orderedQueries (){
				const temp = _.orderBy(this.queries,q=>q.RootInstance.value,'asc')
				return temp
			},
			orderedTree: function () {
				// Determine row visibility per editMode and Branch.isHidden
				const cB = this.Collection.Tree.ClientBranches
				const visibleBranches = cB.filter(cB => {
					const isVisibleLocal = cB.isVisible
					const isHidden = cB.Branch?.isHidden === true
					// Edit mode 0: respect local visibility, ignore hidden flag
					if (this.Collection.editMode === 0) {
						return isVisibleLocal
					}
					// Edit mode > 0: if hidden -> force invisible unless showHiddenBranches is true; else respect local visibility
					if (isHidden && !this.showHiddenBranches) {
						return false
					}
					return isVisibleLocal
				})
				const ordered = _.orderBy(visibleBranches, 'path', 'asc')
				return ordered
			},
			showFilters (){
				const show = this.Collection.rootInstanceID==="" && this.Collection.Root.name !==""?true:false
				return show
			},
			visibleInstances: function (){
				const ITrees = this.Collection.ITrees.ITrees
				if(!_.isEmpty(ITrees)){
					// remove the Instance that is being edited
					const Instances = this.Collection.editMode == 3?ITrees:ITrees.filter (iT => iT.ClientInstances[0].iBranch.Child.ID !== this.Collection.rootInstanceID)
					// if selections are filtered or editMode is 3
					if(this.Collection.flags.filterSelection || this.Collection.editMode == 3){

						return Instances.filter(iT => iT.isSelected)
					}else{
						return Instances
					}
				}else{
					return []
				}
			},
			instancesDivWidth(){
				// Calculate the width of the instances-div
				return this.displayVars.instancesWindow

			},
			useShortHeading(){
				// Use short format when instances-div width is 100px or less
				return this.instancesDivWidth <= 100
			}
		},
		mounted() {
			const bodyDiv = this.$refs.bodyDiv
			if (bodyDiv) {
				bodyDiv.addEventListener('scroll', this.syncBodyScroll, { passive: true })
			}
			window.addEventListener('resize', this.updateBodyMaxHeight)
		},
		updated() {
			this.updateBodyMaxHeight()
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.updateBodyMaxHeight)
			const bodyDiv = this.$refs.bodyDiv
			if (bodyDiv) {
				bodyDiv.removeEventListener('scroll', this.syncBodyScroll)
			}
		},
	}
</script>

<style scoped>

	.no-select{
		-webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
		background: inherit;
		cursor: default;
	}
	.input[type="checkbox"]:hover{
		border-color: red;
	}

	*{
		margin:0;
		padding: 0;
		border: 0;
	}

	.col-1{
		min-width: 15px;
		max-width: 15px;
		margin-right:3px;
	}

	.col-2{
		margin-right:5px;
	}

	.col-3{
		margin-right:10px;
	}

	.button{
			border: 1px solid black;
			border-radius: 4px;
			display: flex;
			justify-content: center;
			height: 24px;
			min-width: 17px;
		}

	.collection{
		border: 2px solid red;
		border-radius: 4px;
		padding: 5px;
		margin-bottom: 5px;
		display: flex;
		flex-direction: column;
		/* max-height: 100%; */
		min-height: 0;
	}
		.control-row{
			display:flex;
			white-space: nowrap;
			margin-bottom: 5px;
		}

			.tool-button{
				align-items: center;
				padding: 0 2px 0 2px;
				margin-left: 1px;
				margin-right: 1px;
				display: inline-flex;
				border: 1px solid black;
				border-radius: 4px;
				height: 24px;
				justify-content: center;
				background-color: #f0f0f0;
			}
				.button-selected{
					background-color: #42f545;
					font-weight: bold;
				}
			.select-root{
				display:inline-flex;
			}
			.collection-title{
				margin-left: 10px;
				font-weight: bold;
				display: flex;
				align-items: center;
				font-size: 15px;
			}
			.group-selector{
				margin-left: 10px;
				padding: 2px 5px;
				border: 1px solid #ccc;
				border-radius: 4px;
				background-color: white;
				font-size: 14px;
				height: 24px;
				align-self: center;
			}
		.query-buttons{
			display:flex;
			gap: 4px;
			align-items: center;
			margin-bottom: 5px;
		}
			.query-component{
				display: inline-block;
			}
			.query-buttons .tool-button{
				margin-left: 0;
				margin-right: 0;
			}
		.group-controls{
			display: flex;
			align-items: center;
			gap: 4px;
			margin-bottom: 5px;
		}
			.group-controls .button{
				align-items: center;
				display: flex;
				justify-content: center;
				height: 24px;
				min-width: 17px;
				border: 1px solid black;
				border-radius: 4px;
				margin-left: 1px;
				margin-right: 1px;
				width: fit-content;
				padding: 2px;
				background-color: #f0f0f0;
				cursor: pointer;
				white-space: nowrap;
			}
			.control-border{
				padding: 1px;
				/* border: 1px solid black; */
				border-radius: 4px;
				width: fit-content;
				background-color: #a6f4e5;
			}
			.groups{
				margin-left: 10px;
			}
			.queries{
				margin-left: 10px;
			}

			.group-controls .button.selected{
				background-color: #42f545;
				font-weight: bold;
			}
			.group-controls .button:hover:not(.selected){
				background-color: #a6f4e5;
			}
			.group-controls .button:focus {
				outline: none;
				box-shadow: 0 0 0 2px rgba(66, 245, 69, 0.5);
			}
		.banner{
			display:flex;
			background-color: #bcf5ea;
		}
		.headers-div{
			display:flex;
			margin-top: 5px;
		}
			.tree-header-div{
				display: inline-flex;
				flex-flow: column nowrap;
				vertical-align: top;
				flex-shrink: 0;
			}
				.col-5{
					margin-left: 5px;
				}
				.col-headings{
					display: flex;
					width: 100%;
				}
				.col-heading{
					position:relative;
					border-radius: 4px;
					display: flex;
					font-weight: bold;
					justify-content: center;
					background-color: #bce8df;
					align-items: center;
					height: 24px;
				}
				.collection-heading{
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					justify-content: flex-start;
					padding: 0 5px;

					flex: 1 1 auto;
					max-width: 100%;
				}
				.collection-heading.short{
					text-overflow: clip;
				}
				.tree-tools{
					display: flex;
					margin-top: 10px;
				}
					.row-toggle-button{
						border-radius: 5px;
						display: flex;
						height: 22px;
						margin-top:2px;
						width: 12px;
						justify-content: center;
					}
				.tree-buttons{
					position:relative;
					display: flex;
					justify-content: center;
					white-space: nowrap;
				}
				.show-hidden-toggle{
					display: inline-flex;
					align-items: center;
					gap: 4px;
					margin-left: 6px;
					font-size: 0.85rem;
				}
				.show-hidden-toggle input{
					margin: 0;
				}
				.show-hidden-toggle label{
					cursor: pointer;
				}
				.filter-buttons{
					position: relative;
					display: flex;
					justify-content: center;
					white-space: nowrap;
				}
			.instance-headers-outer-div{
				position:relative;
				display: inline-flex;
				flex-flow: column;
				vertical-align: top;
				flex: 1;
				min-width: 0;
			}
			.editInstance-header-div{
				margin-right: 5px;
				flex: 0 0 auto;
			}
			.arrow-into{
				display:inline-flex;
			}
			.button-image{
				height: 15px;
			}
			.disabled{
				opacity:0.3;
			}
			.instance-headers-div{
				scrollbar-width: none; /* Firefox */
				-ms-overflow-style: none;  /* IE and Edge */
				display: flex;
				flex-direction: row;
				vertical-align: top;
				overflow-x: hidden;
				width: 100%;
				box-sizing: border-box;
			}
				.instance-tools-div{
					background-color: yellow;
					height: 24px;
					white-space: nowrap;
					overflow: hidden;
				}
				.instance-scroll-div{
					height: 10px;
					/* display: block; */
					white-space: nowrap;
					overflow-x: auto;
					overflow-y: hidden;
					width: 100%;
					box-sizing: border-box;
				}
					.instance-scroll-filler{
						height: 6px;
					}
			.filter-tools,.instance-header{
				display: inline-block;
			}
				.instance-header{
					/* margin-right: 5px; */
					vertical-align:bottom;
					flex-shrink: 0;
				}
			.filter-chkbox{
				margin-left: .5px;
			}
				.instance-tools{
					padding-left:10px;
					display: flex;
					vertical-align: center;

				}
				.instance-header .box{
				border-bottom: 0.1px solid black;
			}
		.body-div {
				}
				.instance-scroll-div{
					height: 10px;
					/* display: block; */
					white-space: nowrap;
					overflow-x: auto;
					overflow-y: hidden;
					width: 100%;
					box-sizing: border-box;
				}
					.instance-scroll-filler{
						height: 6px;
					}
			.filter-tools,.instance-header{
				display: inline-block;
			}
				.instance-header{
					/* margin-right: 5px; */
					vertical-align:bottom;
					flex-shrink: 0;
				}
			.filter-chkbox{
				margin-left: .5px;
			}
				.instance-tools{
					padding-left:10px;
					display: flex;
					vertical-align: center;

				}
				.instance-header .box{
				border-bottom: 0.1px solid black;
			}
		.body-div {
			scrollbar-width: none; /* Firefox */
			-ms-overflow-style: none;  /* IE and Edge */
			display:flex;
			flex-direction: row;
			flex: 1 1 auto;
			min-height: 0;
			max-height: inherit;
			overflow-y: auto;
			overflow-x: hidden;
			scrollbar-gutter: stable;
			align-items: flex-start;
			position: relative;
		}
		.body-div::-webkit-scrollbar { display: none; }
			.tree-component{
				overflow: visible;
				flex: 0 0 auto;
				min-height: 100%;
			}
			.editInstance-div{
				overflow: visible;
				flex: 0 0 auto;
				min-height: 100%;
			}
			.instances-div{
				scrollbar-width: none; /* Firefox */
				-ms-overflow-style: none;  /* IE and Edge */
				position: relative;
				vertical-align: top;
				white-space: nowrap;
				overflow-x: auto;
				overflow-y: visible;
				flex: 1;
				min-width: 0;
				min-height: 100%;
			}
			.instance{
				display: inline-block;
				vertical-align: top;
				position: relative;
			}
			.instances-div::-webkit-scrollbar {
					display: none;
				}
				.instance-headers-div::-webkit-scrollbar {
					display: none;
				}
	.box{
		border-left: 1px solid black;
		border-top: 1px solid black;
		border-right: 1px solid black;
	}

	.cell{
		max-height: 22.4px;
		min-height: 22.4px;
		display:flex;
		align-items: center;
	}
	.modal-overlay {
		background-color: #bce8df;
	}

	.edit{
		padding-right: 4px;
	}
	.button-spacer,
	.button-container{
		display:inline-block;
	}
	@media (hover: hover) {
		.hover:hover{
			cursor: pointer;
			background: #a6f4e5;
		}
	}
</style>